export let FocusSource = /*#__PURE__*/function (FocusSource) {
  FocusSource["mouse"] = "mouse";
  FocusSource["keyboard"] = "keyboard";
  return FocusSource;
}({});